import React, { useState, useRef, useEffect } from "react";
import { getCSSRS } from "../services/soar";
import { getFieldDate, getFieldName } from "../../scripts/helperScripts";

function CaseyLifeSkills({ contactID }) {
  const [expanded, setExpanded] = useState(false);
  const [caseyLifeSkills, setCaseyLifeSkills] = useState();
  const isMountedRef = useRef(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Get Casey Life Skills
  useEffect(() => {
    if (expanded) {
      console.log("Getting Casey Life Skills for ", contactID);
      // getCaseyLifeSkills(contactID).then((response) => {
      //   console.log("CaseyLifeSkills: ", response);
      //   if (response && isMountedRef.current) {
      //     setCaseyLifeSkills(response);
      //     setLoaded(true);
      //   }
      // });

      return () => (isMountedRef.current = false);
    } else {
      setCaseyLifeSkills([]);
    }
  }, [expanded]);

  useEffect(() => {
    setLoaded(false);
  }, [expanded]);

  const add = () => {
    var org =
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "https://careboard.safy.org"
        : "https://d365base-cb.safy.org";

    const url = `${org}/FormBuilder?contactId=${contactID}`;
    window.open(url, "Casey Life Skills");
  };

  // const openCaseyLifeSkills = (id) => {
  //   var org =
  //     process.env.REACT_APP_ENVIRONMENT === "Production"
  //       ? "https://careboard.safy.org"
  //       : "https://d365base-cb.safy.org";

  //   const url = `${org}/FormBuilder?contactId=88ca1b03-e0f6-eb11-abdb-000c29f4947d`;
  //   window.open(url, "Casey Life Skills");
  // };

  return (
    <div className="border p-2 mb-4 card-safy">
      <div className="ms-4 h6">
        {/* <i
          title="Edit"
          className={
            expanded
              ? "fas fa-chevron-up p-1 text-primary"
              : "fas fa-chevron-down p-1 text-primary"
          }
          onClick={() => setExpanded(!expanded)}
        ></i> */}
        Casey Life Skills
        <i
          title="Add"
          className="fas fa-plus-circle float-end p-1 text-primary"
          onClick={add}
        ></i>
      </div>
      {/* {expanded &&
        (caseyLifeSkills.length > 0 ? (
          caseyLifeSkills.map((c) => (
            <div className="p-2 m-2 text-white bg-safy3-1 row">
              <div className="col">{getFieldDate(c.sor_date)}</div>
              <div className="col">{getFieldName(c.sor_timeframe)}</div>
              <div className="col">{c.sor_severity}</div>
              <i
                title="Edit"
                onClick={() => openCaseyLifeSkills(c.clsid)}
                className="fas fa-pen float-end p-1"
              ></i>
            </div>
          ))
        ) : loaded === true ? (
          <div>No Casey Life Skills records for client</div>
        ) : (
          <div>Loading</div>
        ))} */}
    </div>
  );
}

export default CaseyLifeSkills;
